import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "card-content" };
const _hoisted_2 = { class: "top-section d-flex justify-space-between align-center" };
const _hoisted_3 = { class: "label" };
const _hoisted_4 = {
    key: 0,
    class: "amount font-weight-bold"
};
const _hoisted_5 = { class: "bottom-section d-flex align-center" };
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "savings-info" };
const _hoisted_8 = { class: "saving-amount font-weight-bold" };
const _hoisted_9 = { class: "saving-percentage" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherSavingSuggestions',
    props: {
        label: {},
        labelValue: {},
        logoBackgroundColor: {},
        logoUrl: {},
        logoAltText: {},
        savingAmount: {},
        savingPercentage: {},
        formatter: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, {
                class: "saving-opportunity-card",
                ripple: false,
                elevation: "0"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1),
                            (_ctx.labelValue)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.labelValue), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_v_divider, { class: "my-2" }),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["logo-url", { 'logo-background': _ctx.savingPercentage == 0 }])
                            }, [
                                _createElementVNode("img", {
                                    src: _ctx.logoUrl,
                                    class: "logo-image"
                                }, null, 8, _hoisted_6)
                            ], 2),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.savingAmount), 1),
                                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.savingPercentage) + "%", 1)
                            ])
                        ])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
